<template>
  <div class="unsupportedBrowserMsg">
    <div class="unsupportedBrowserMsg__content-wrapper">
      {{ $t("unsupportedBrowserMsg") }}
<!--      <div class="unsupportedBrowserMsg__btn-close">-->
<!--        <svg xmlns="http://www.w3.org/2000/svg" fill="white" viewBox="0 0 36 36">-->
<!--          <path-->
<!--            d="M30.732 5.272c-7.028-7.02-18.416-7.017-25.44.008-7.022 7.026-7.022 18.414 0 25.44 7.024 7.025 18.412 7.029 25.44.008 7.017-7.035 7.017-18.421 0-25.456zm-5.668 17.646a1.5 1.5 0 0 1-2.114 2.123l-4.665-4.665a.378.378 0 0 0-.531 0l-4.664 4.665a1.528 1.528 0 0 1-2.122 0 1.5 1.5 0 0 1 0-2.122l4.665-4.664a.374.374 0 0 0 0-.53l-4.665-4.665a1.5 1.5 0 0 1 2.115-2.122l4.664 4.665a.375.375 0 0 0 .53 0l4.665-4.665a1.5 1.5 0 1 1 2.122 2.122l-4.666 4.665a.375.375 0 0 0 0 .53l4.666 4.664z" />-->
<!--        </svg>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: 'UnsupportedBrowserMsg',
  mounted() {
  }
};
</script>
